<template>
  <div class="research_group_container" v-if="researchGroupCharacter === 'leader'">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">设置{{ characterToDisplay }}</span>
    </div>
    <div class="box">
      <div class="bd">
        <span class="currentReconciler">当前{{ characterToDisplay }}</span>
        <div class="avatorWrap">
          <img
            class="avator"
            src="/static/img/avator2.png"
          />
          <span class="liuChengbiao">{{characterNameToDisplay}}</span>
        </div>
        <div class="block">
          <div class="research-background-color open-popup open-researchGroupMember" :class="character === 'horMember' ? 'tagWrap2' : 'tagWrap'" data-popup=".popup-researchGroupMember">
            <span class="tag">更换{{ characterToDisplay }}</span></div>
        </div>
      </div>
    </div>
    <ResearchGroupRemindBox :remindParams="remindParams" v-if="showResearchGroupRemindBox" @toggleShow="toggleResearchGroupRemindBox"/>
  </div>
</template>
<script>
import {mapGetters, mapState, mapMutations} from 'vuex'
import ResearchGroupRemindBox from './../researchGroupComponents/ResearchGroupRemindBox'
import EMKT from '../../../../emkt'
import $ from 'jquery'
export default {
  data () {
    return {
      character: this.$route.query.character,
      showResearchGroupRemindBox: false,
      remindParams: {
        firstline: '',
        secondline: '',
        singleOrDouble: 1
      },
      isWapp: EMKT.isWapp
    }
  },
  components: {
    ResearchGroupRemindBox
  },
  computed: {
    ...mapState([
      'researchGroupMemberMap', 'researchGroupSet', 'chosenResearchMember'
    ]),
    ...mapGetters([
      'displayChosenResearchGroup', 'researchGroupCharacter'
    ]),
    characterToDisplay () { // 显示审批人/对账人
      if (this.character === 'approver') return '审批人'
      if (this.character === 'accountCustomer') return '对账人'
      if (this.character === 'horMember') return '科研者之家会员'
      return ''
    },
    characterNameToDisplay () {
      if (this.character === 'approver') return this.displayChosenResearchGroup.approverName
      if (this.character === 'accountCustomer') return this.displayChosenResearchGroup.accountCustomerName
      if (this.character === 'horMember') return this.displayChosenResearchGroup.horMemberName
      return ''
    }
  },
  watch: {
    chosenResearchMember (val) {
      console.log('chosenResearchMember', val)
      if (val && JSON.stringify(val) !== '{}') this.ifEmailExist(val)
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_RESEARCHGROUP_SET'
    ]),
    goBack () {
      this.$router.go(-1)
    },
    ifEmailExist (member) {
      if (this.character === 'accountCustomer' && !member.email) {
        // 查询此成员邮箱是否已更新
        const queryParam = {
          researchGroupNo: member.researchGroupNo,
          memberNo: member.memberNo
        }
        this.gcapi('getResearchGroupMemberInfo', queryParam).then(res => {
          if (res && res.body.result) {
            const newEmail = res.body.result.email
            if (!newEmail) {
              this.remindParams.firstline = '对账联系人邮箱不能为空'
              this.remindParams.secondline = '请提醒此成员添加邮箱（添加方式：淘基因-我的个人中心-修改个人信息-修改邮箱）'
              this.remindParams.singleOrDouble = 1
              this.toggleResearchGroupRemindBox()
              return
              // $.alert('对账联系人邮箱不能为空，请提醒此成员添加邮箱（添加方式：电商平台-我的个人中心-修改个人信息-修改邮箱）')
            } else {
              this.saveResearchGroup(member)
            }
          }
        })
      } else {
        this.saveResearchGroup(member)
      }
    },
    saveResearchGroup (val) {
      const name = this.character === 'approver' ? 'approverName' : this.character === 'accountCustomer' ? 'accountCustomerName' : 'horMemberName'
      const no = this.character === 'approver' ? 'approverNo' : this.character === 'accountCustomer' ? 'accountCustomerNo' : 'horMemberNo'
      const researchGroupToUpdate = {...this.displayChosenResearchGroup}
      researchGroupToUpdate[name] = val.memberName
      researchGroupToUpdate[no] = val.memberNo
      console.log('researchGroupToUpdate', researchGroupToUpdate)
      // 更新课题组审批人/对账人
      $.showPreloader('保存中')
      this.gcapi('updateResearchGroup', researchGroupToUpdate).then(res => {
        $.hidePreloader()
        if (res && res.body.result) {
          const updatedResearchGroup = res.body.result
          // 更新内存中课题组的信息，this.$set()可以监测数组的变化
          const researchGroupSetToUpdate = [...this.researchGroupSet]
          for (let i = 0; i < researchGroupSetToUpdate.length; i++) {
            const group = researchGroupSetToUpdate[i]
            if (group.researchGroupNo === updatedResearchGroup.researchGroupNo) {
              // this.$set(researchGroupSetToUpdate, i, Object.assign(group, updatedResearchGroup))
              researchGroupSetToUpdate[i] = updatedResearchGroup
              this.UPDATE_RESEARCHGROUP_SET(researchGroupSetToUpdate)
            }
          }
          console.log('课题组保存成功', this.researchGroupSet)
          $.toast('课题组保存成功')
        } else {
          $.toast('课题组保存失败，请重试')
        }
      })
    },
    toggleResearchGroupRemindBox () {
      this.showResearchGroupRemindBox = !this.showResearchGroupRemindBox
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:scroll;
  overflow-x:hidden;
  /*-webkit-overflow-scrolling:touch;*/
  height:100%;
  width: 100%;
}
.box {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100vw;
  height: 196.27vw;
  top: 14.93vw;
}
.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

.bd {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 6.67vw;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  height: 63.2vw;
}

.currentReconciler {
  opacity: 1;
  margin-top: 5.33vw;
  margin-left: 6.67vw;
  max-width: 80vw;
  height: 5.33vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: 400;
}

.avatorWrap {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 5.87vw;
  width: 86.4vw;
  height: 21.07vw;
}

.avator {
  width: 21.07vw;
  height: 21.07vw;
  border-radius: 10.53vw;
}

.liuChengbiao {
  display: flex;
  flex-direction: row;
  justify-content: center;
  opacity: 1;
  margin-left: 6.67vw;
  max-width: 33.87vw;
  height: 7.47vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 7.47vw;
  white-space: nowrap;
  color: #424242;
  font-size: 5.33vw;
  font-weight: 500;
}

.block {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 5.33vw;
  width: 86.4vw;
}

.tagWrap {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  padding-right: 27.47vw;
  padding-left: 27.47vw;
  height: 13.33vw;
}

.tagWrap2 {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  padding-right: 21.47vw;
  padding-left: 21.47vw;
  height: 13.33vw;
}

.tag {
  opacity: 1;
  text-align: center;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// ResearchMemberCharacterSetting.vue?e33eb9f6